import Lottie from 'lottie-react';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import { ApiService } from "../../components/Common/ApiService";
import Button from './Button';

import animationEmtpyData from '../../assets/elements/searching-for-location.json';
import { useHandleClickLoading } from './utils';

const SearchBox = ({ active, onClose, className }) => {
    const [isSearching, setSearching] = useState("");
    const searchInputRef = useRef(null);

    const [searchData, setSearchData] = useState([]);

    const handleClickLoading = useHandleClickLoading();

    useEffect(() => {
        if (active) {
            searchInputRef.current.focus();
            getSearch(isSearching);
        }
    }, [active, isSearching]);

    useEffect(() => {
        const handleKeyPress = event => {
            if (event.key === "Escape" && active) {
                onClose();
            }
        };
        window.addEventListener("keydown", handleKeyPress);
        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, [onClose]);

    const getSearch = async (keyword) => {
        try {
            const response = await ApiService({
                baseurl: "user/search",
                parameter: `search=${keyword}`,
                method: "POST",
                XGORDON: "SEARCH"
            });
            if (response?.statusCode === 200) {
                setSearchData(response.result.data);
            } else {
                setSearchData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    return (
        active &&
        <div
            className={`fixed flex flex-col items-center sm:pt-[100px] top-0 left-0 right-0 bottom-0 bg-[#21212195] backdrop-blur-sm z-10 ${className}`} >
            <div className="flex flex-col bg-cardLight dark:bg-cardDark lg:rounded-lg  sm:max-w-5xl w-full max-h-full overflow-x-auto z-10">
                <div className="flex flex-col gap-3 bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] h-4 lg:rounded-tl-lg lg:rounded-tr-lg " />
                <div className="flex flex-col gap-2">
                    <div className='flex items-center p-3 py-1 flex-row border-b border-[#999999]'>
                        <SearchIcon className=" h-6 w-6" fill="#666666" />
                        <input
                            value={isSearching}
                            ref={searchInputRef}
                            onChange={event => {
                                setSearching(event.target.value);
                            }}
                            type="text"
                            className="text-base h-7 m-2.5 flex-1 w-full  outline-none bg-transparent focus:outline-none focus:ring-0 "
                            placeholder="Cari Game, Hero, item, Voucher"
                        />
                        <div className="sm:flex hidden items-center justify-center gap-3 p-2 border-1 border-[#c4c4c4]   px-3 rounded-md">
                            <span className=" text-xs">Esc</span>
                        </div>
                    </div>
                    <div className="flex  p-3 flex-row h-full justify-center overflow-auto">
                        {searchData.length === 0 ? (
                            <div className="flex flex-col gap-2 items-center justify-center py-5">
                                <Lottie animationData={animationEmtpyData} loop autoplay className="w-[50%]" />
                                <span className="text-base text-center opacity-70">Produk Tidak Tersedia</span>
                            </div>
                        ) : (
                            <div className="flex flex-col w-full">
                                {searchData.map((item, index) => (
                                    <button
                                        onClick={() => {
                                            onClose();
                                            setSearching('');
                                            handleClickLoading('/beli/' + item.slug)
                                        }}
                                        key={index}
                                        className="rounded-md p-2 flex w-full justify-start hover:bg-[#f3f3f3] hover:p-2 items-center group space-x-3 transform  ease-out"
                                    >
                                        <img src={item.gambar} alt={item.nama} className="object-cover object-center rounded-full h-8 w-8" />
                                        <div className="flex flex-col items-start">
                                            <span className=" opacity-70 group-hover:text-[#1b1b41] text-base group-hover:font-medium group-hover:transform  ease-out text-left">{item.nama}</span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className='absolute top-2 right-2 left-2 bottom-2 cursor-pointer'  onClick={onClose}>
            </div>
        </div>
    );
};

export default SearchBox;
